import React, { Component } from "react";
import PropTypes from "prop-types";
import { KJUR } from "jsrsasign";
const ZoomVideo = window.WebVideoSDK.default;
const ZOOM_VIDEO_SDK_KEY = process.env.REACT_APP_ZOOM_VIDEO_SDK_KEY;
const ZOOM_VIDEO_SDK_SECRET = process.env.REACT_APP_ZOOM_VIDEO_SDK_SECRET;
const zoomVideo = ZoomVideo.createClient();
let zoomSession;

class Zoom extends Component {
  constructor(props) {
    super(props);
    this.joinRoom = this.joinRoom.bind(this);
    this.leaveRoom = this.leaveRoom.bind(this);
    this.state = {
      activeRoom: false,
      token: "",
    };
  }

  generateSignature(
    sdkKey,
    sdkSecret,
    sessionName,
    role,
    sessionKey,
    userIdentity
  ) {
    const iat = Math.round(new Date().getTime() / 1000) - 30;
    const exp = iat + 60 * 60 * 2;
    const oHeader = { alg: "HS256", typ: "JWT" };

    const oPayload = {
      app_key: sdkKey,
      tpc: sessionName,
      role_type: role,
      session_key: sessionKey,
      user_identity: userIdentity,
      version: 1,
      iat: iat,
      exp: exp,
    };

    const sHeader = JSON.stringify(oHeader);
    const sPayload = JSON.stringify(oPayload);
    const sdkJWT = KJUR.jws.JWS.sign("HS256", sHeader, sPayload, sdkSecret);
    this.setState({ token: sdkJWT });
    return sdkJWT;
  }

  componentDidMount() {
    this.props.onRef(this);
    console.log("Connected to Twilio: " + this.props.identity);
    this.generateSignature(
      ZOOM_VIDEO_SDK_KEY,
      ZOOM_VIDEO_SDK_SECRET,
      this.props.roomName,
      1,
      "session",
      this.props.identity,
      "password"
    );
    this.joinRoom();
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  leaveRoom() {
    this.setState({activeRoom:false})
    zoomVideo.leave();
    zoomSession.stopAudio();
  }

  async joinRoom() {
    console.log("Trying to connect to Zoom with token", this.state.token);
    if (
      ZoomVideo.checkSystemRequirements().video &&
      ZoomVideo.checkSystemRequirements().audio
      ) {
        await zoomVideo.init("en-US", "Global", { patchJsMedia: true });
        await zoomVideo
        .join(
          this.props.roomName,
          this.state.token,
          this.props.identity,
          "password"
          )
          .then(async (res) => {
            this.setState({activeRoom:true});
          zoomSession = zoomVideo.getMediaStream();
          zoomSession.startAudio();
          if (zoomSession.isRenderSelfViewWithVideoElement()) {
            await zoomSession.startVideo({
              videoElement: document.getElementById("my-self-view-video"),
            });
          }
          zoomVideo.getAllUser().forEach((user) => {
            if (user.bVideoOn) {
              zoomSession.renderVideo(
                document.querySelector("#participant-videos-canvas"),
                user.userId,
                386,
                216,
                0,
                0,
                3
              );
            }
          });
        });
    }
  }

  render() {
    return (
      <div>
        {this.state.activeRoom ? (
          <div style={{ position: "relative" }}>
            <video
              id="my-self-view-video"
              style={{
                borderRadius: "10px",
                width: "620px",
                height: "350px",
              }}
            ></video>
            <canvas
              id="participant-videos-canvas"
              style={{
                borderRadius: "10px",
                position: "absolute",
                zIndex: "10",
                bottom: "8px",
                right: "5px",
                width: '200px',
                height: '125px'
              }}
            ></canvas>
          </div>
        ) : ("")}
      </div>
    );
  }
}

Zoom.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default Zoom;



// WEBPACK FOOTER //
// ./src/components/TwilioProgrammableVideo/ZoomVideo.js